// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    hideLoadingOverlay,
    xngLoadingOverlayUtilitiesStyles,
} from "@steiner/App/Components/Common/XngLoadingOverlayUtilities";
import { menuBodyStyle } from "@steiner/App/Components/Menu/DropdownMenu";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { xBaseTheme } from "@steiner/XDL/types";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

export default {
    css: css`
        ${hideLoadingOverlay}
        ${xngLoadingOverlayUtilitiesStyles}

        :root {
            --header-height: 100px;
            --compact-header-height: 47px;
        }

        html,
        body {
            scrollbar-gutter: stable;
        }
        body {
            /* Better Font Rendering */
            font-variant-ligatures: no-common-ligatures;
            text-rendering: optimizeLegibility;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            font-family: ${fontConfig.bodyFontFamily};
        }

        // This style to fix an issue with Google Places autocomplete
        .pac-container {
            z-index: 10000 !important;
        }

        [data-lastpass-root] {
            z-index: 10 !important;
        }

        .xSmall {
            font-size: ${fontConfig.fontSize.xSmall}px;
            line-height: ${fontConfig.lineHeight.xSmall};
        }


        // https://xngage.atlassian.net/browse/STR-2547 - Adding temporary classes until we create the custom widgets
        .bordered-table {
            border: 1px solid ${color("common.ui3")};
            border-collapse: collapse;

            th {
                border-bottom: 1px solid ${color("common.ui3")};
            }
            
        }

        .spacious-table {
            border-collapse: collapse;
            
            th,
            td {
                padding: 5px 15px;
            }
        }

        .colored-table {
            border-collapse: collapse;
            
            tr:nth-child(even) {
                background-color: ${color("common.ui14")};
            }

            tr:nth-child(odd) {
                background-color: ${color("common.ui1")};
            }
        }


        ${menuBodyStyle}
    `,
} as xBaseTheme["globalStyle"];
